export type Bonus = {
  index: string
  emoji: string
  title: string
  description: string
  includes: string[]
  value: string
  image: string
  imageAlt: string
}

export const bonuses: Bonus[] = [
  {
    index: 'SISTEMA PREMIUM #1',
    emoji: '🔧',
    title: 'SISTEMA LABORATORIO PRODUTTIVO™',
    description:
      'Trasforma qualsiasi spazio in un laboratorio organizzato che ti permetta di completare più riparazioni in meno tempo.',
    includes: [
      'Metodo 5S adattato ai laboratori',
      'Organizzazione intelligente degli strumenti',
      'Controllo dei ricambi',
      'Flusso di lavoro consigliato',
      'Checklist quotidiana della produttività',
    ],
    value: '37 €',
    image:
      'https://cdn.magicpatterns.com/uploads/nKRftAkcJQoEUb6W1cUutE/BONUS_1_REPARACIONES-IT.png',
    imageAlt:
      'Sistema Laboratorio Produttivo™: manuale principale, checklist giornaliera, guida al metodo 5S e mappa del flusso di lavoro',
  },
  {
    index: 'SISTEMA PREMIUM #2',
    emoji: '💰',
    title: 'SISTEMA ACQUISTI INTELLIGENTI™',
    description:
      'Impara ad acquistare ricambi come un tecnico professionista e aumenta i tuoi guadagni senza effettuare una sola riparazione in più.',
    includes: [
      'Elenco di fornitori',
      'Comparatore dei prezzi',
      'Metodo di negoziazione',
      'Valutazione dei fornitori',
      'Strategia per acquisti intelligenti',
    ],
    value: '47 €',
    image:
      'https://cdn.magicpatterns.com/uploads/niA57t91dPVMgeLiJ3iRXW/BONUS_2_REPARACIONES-IT.png',
    imageAlt:
      'Sistema Acquisti Intelligenti™: manuale, direttorio di fornitori verificati, comparatore prezzi, checklist e guida alla negoziazione',
  },
  {
    index: 'SISTEMA PREMIUM #3',
    emoji: '🛡️',
    title: 'SISTEMA GARANZIA BLINDATA™',
    description:
      'Evita clienti problematici e proteggi la tua reputazione con un sistema di garanzie professionale. I conflitti nascono quando le condizioni non sono chiare.',
    includes: [
      'Modelli di garanzia',
      'Condizioni di copertura',
      'Protocolli per i reclami',
      'Script per comunicare le garanzie',
      'Casi pratici',
    ],
    value: '47 €',
    image:
      'https://cdn.magicpatterns.com/uploads/wdqbD5t3hysK9zoni5rZhY/BONUS_3_REPARACIONES-IT.png',
    imageAlt:
      'Sistema Garanzia Blindata™: manuale, moduli di garanzia, guida alla gestione dei reclami e script di comunicazione',
  },
  {
    index: 'SISTEMA PREMIUM #4',
    emoji: '📈',
    title: 'SISTEMA GUADAGNO REALE™',
    description:
      'Scopri quanti soldi stai perdendo senza rendertene conto e impara a calcolare il profitto reale di ogni riparazione.',
    includes: [
      'Calcolatore dei costi',
      'Costi nascosti',
      'Tempo non fatturato',
      'Costi operativi',
      'Profitto reale',
    ],
    value: '37 €',
    image:
      'https://cdn.magicpatterns.com/uploads/x2vSinQ186KHca2y28aaSZ/BONUS_4_REPARACIONES-IT.png',
    imageAlt:
      'Sistema Guadagno Reale™: manuale, calcolatore costi e profitto reale, guida in 5 passi e elenco dei costi nascosti',
  },
  {
    index: 'SISTEMA PREMIUM #5',
    emoji: '📲',
    title: 'SISTEMA WHATSAPP VENDITORE™',
    description:
      'Fai in modo che WhatsApp risponda ai clienti, invii preventivi e trasmetta un’immagine professionale anche mentre stai lavorando.',
    includes: [
      'Messaggi automatici',
      'Preventivi rapidi',
      'Catalogo ottimizzato',
      'Follow-up dei clienti',
      'Script di chiusura',
    ],
    value: '67 €',
    image:
      'https://cdn.magicpatterns.com/uploads/3uHpDukkuNCCpydWqc6VYh/BONUS_5_REPARACIONES-IT.png',
    imageAlt:
      'Sistema WhatsApp Venditore™: manuale, messaggi automatici, catalogo servizi, preventivo rapido e script di chiusura',
  },
]
